import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { GraficoSaldoGeracao } from "../../fatura/components/GraficoSaldoGeracao";

import { setModoTela, setDataGrafico, getListaGraficoGeracaoEconomia, getGeracaoCadastro, getListaUnidadeConsumidora, getListaGraficoGeracaoSaldo } from "../geracaoLeituraActions";
import ContentCard from "../../common/template/contentCard.jsx";
import ContentCardBody from "../../common/template/contentCardBody.jsx";
import Grid from "../../common/layout/grid.jsx";
import Button from "../../common/button/button.jsx";
import { RowFlex } from "../../common/layout/RowFlex.jsx";
import { GraficoDia } from "./GraficoDia.jsx";
import { GraficoMes } from "./GraficoMes.jsx";
import { GraficoAno } from "./GraficoAno.jsx";
import { GraficoRetornoFinanceiro } from "../../analise/components/GraficoRetornoFinanceiro.jsx";
import { GraficoEconomia } from "../../analise/components/GraficoEconomia.jsx";
import { AbasGraficosDiaMesAno } from "./AbasGraficosDiaMesAno.jsx";

function GeracaoLeituraGraficosComponent(props) {
    const [ucFiltro, setUcFiltro] = useState({});
    const [ucFiltradaComRemotas, setUcFiltradaComRemotas] = useState([]);
    const umaUnicaFiltrada = true; //como aqui analisa unidades indivudualmente, isso fica true

    useEffect(() => {
        if (props.modoTela === "graficoRetornoFinanceiro") {
            props.getGeracaoCadastro({ id_cliente: props.registro.id_cliente, id_unidade_consumidora: props.registro.id_unidade_consumidora });
            props.getListaGraficoGeracaoEconomia({ id_cliente: props.registro.id_cliente, id_unidade_consumidora: props.registro.id_unidade_consumidora });
        }
        if (props.modoTela === "graficoEconomia") {
            props.getListaUnidadeConsumidora();
        }
        if (props.modoTela === "graficoGeracaoSaldo") {
            props.getListaGraficoGeracaoSaldo({
                id_cliente: props.registro.id_cliente,
                id_unidade_consumidora: props.registro.id_unidade_consumidora,
            });
        }
    }, [props.modoTela, props.registro]);

    useEffect(() => {
        if (props.modoTela === "graficoEconomia") {
            //simula um filtro, pq no módulo de análise tem filtro, e considera a uc carregada no registro como uma filtrada
            const ucFiltroEncontrada = props.listaUnidadeConsumidora.find((uc) => uc.id == props.registro.id_unidade_consumidora) || {};

            // console.log("ucFiltroEncontrada", ucFiltroEncontrada);
            setUcFiltro(ucFiltroEncontrada);

            const ucComRemotas = props.listaUnidadeConsumidora.filter(
                (uc) => umaUnicaFiltrada && ucFiltroEncontrada.id && (uc.id == ucFiltroEncontrada.id || uc.id_unidade_geradora == ucFiltroEncontrada.id)
            );
            // console.log("ucComRemotas", ucComRemotas);
            setUcFiltradaComRemotas(ucComRemotas);
            props.getListaGraficoGeracaoEconomia({ id_cliente: props.registro.id_cliente, id_unidade_consumidora: props.registro.id_unidade_consumidora });
        } else {
            setUcFiltro({});
            setUcFiltradaComRemotas([]);
        }
    }, [props.modoTela, JSON.stringify(props.listaUnidadeConsumidora)]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <ContentCard style={{ backgroundColor: "#fff", paddingLeft: 0 }}>
            <ContentCardBody padding="10px">
                <RowFlex style={{ justifyContent: "flex-end" }}>
                    <Grid cols="12 4 4 2">
                        <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={props.voltar} />
                    </Grid>
                </RowFlex>
                <AbasGraficosDiaMesAno />
                {props.modoTela === "graficoEnergiaDia" && <GraficoDia />}
                {props.modoTela === "graficoEnergiaDiasMes" && <GraficoMes />}
                {props.modoTela === "graficoEnergiaMesesAno" && <GraficoAno />}
                {props.modoTela === "graficoGeracaoSaldo" && <GraficoSaldoGeracao registro={props.registro} listaGraficoGeracaoSaldo={props.listaGraficoGeracaoSaldo} />}
                {props.modoTela === "graficoRetornoFinanceiro" && (
                    <GraficoRetornoFinanceiro
                        bulletLabelDy={10}
                        backgroundColor="#FFF"
                        fontColor="#222"
                        listaGraficoGeracaoEconomia={props.listaGraficoGeracaoEconomia}
                        listaGeracaoContrato={props.listaGeracaoContrato}
                    />
                )}
                {props.modoTela === "graficoEconomia" && (
                    <GraficoEconomia
                        bulletLabelDy={10}
                        backgroundColor="#FFF"
                        fontColor="#222"
                        listaGraficoGeracaoEconomia={props.listaGraficoGeracaoEconomia}
                        ucFiltro={ucFiltro}
                        umaUnicaFiltrada={true}
                        ucFiltradaComRemotas={ucFiltradaComRemotas}
                    />
                )}
            </ContentCardBody>
        </ContentCard>
    );
}

const mapStateToProps = (state) => {
    return {
        modoTela: state.geracaoLeitura.modoTela,
        registro: state.geracaoLeitura.registro,
        listaGraficoGeracaoSaldo: state.geracaoLeitura.listaGraficoGeracaoSaldo,
        listaGeracaoContrato: state.geracaoLeitura.listaGeracaoContrato,
        listaGraficoGeracaoEconomia: state.geracaoLeitura.listaGraficoGeracaoEconomia,
        listaUnidadeConsumidora: state.geracaoLeitura.listaUnidadeConsumidora,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            setDataGrafico,
            getGeracaoCadastro,
            getListaUnidadeConsumidora,
            getListaGraficoGeracaoEconomia,
            getListaGraficoGeracaoSaldo,
        },
        dispatch
    );
export const GeracaoLeituraGraficos = connect(mapStateToProps, mapDispatchToProps)(GeracaoLeituraGraficosComponent);
